<template>
  <q-chip
    :color="color"
    class="tour-status-badge"
  >
    {{ label }}
  </q-chip>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      color: null,
      label: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const tourStatus = this.status;

      let color = 'grey-3';
      if (tourStatus.includes('Scheduled - Agent Matched')) {
        color = 'blue-5';
      }
      if (tourStatus.includes('Looking for agent')) {
        color = 'yellow-orange';
      }
      if (tourStatus.includes('Completed')) {
        color = 'green';
      }
      if (tourStatus.includes('Self-showing')) {
        color = 'purple';
      }
      if (tourStatus.includes('Missing Report')) {
        color = 'green';
      }
      if (['Technical issue', 'About to expire'].includes(tourStatus)) {
        color = 'orange';
      }
      if (['No agent found', 'Cancelled by agent'].includes(tourStatus)) {
        color = 'red';
      }
      if (['Scheduled'].includes(tourStatus)) {
        color = 'yellow';
      }
      if (['Cancelled by pm', 'Taken Over'].includes(tourStatus)) {
        color = 'purple';
      }
      this.label = tourStatus;
      this.color = color;
    },
  },
};
</script>

<style lang="scss">
    .tour-status-badge {
        color: black !important;
        padding: 7px;
        border-radius: 0.5rem;
        display: block;
    }
    .tour-status-badge.bg-purple{
        color: white !important;
    }
</style>
